import { useState, useEffect, useCallback } from 'react';
import { FeedDto } from '@/api/feed';
import api from '@/api';
import { useEventBus } from '@/hooks/use-event-bus';

// Event name for feed like status changes
const FEED_LIKE_EVENT = 'feed-like-status-change';

// Event payload type
interface FeedLikeEvent {
  feedId: string;
  isLiked: boolean;
  likeCount?: number;
}

/**
 * Hook for fetching feed data
 */
export const useFeedLike = (feed?: FeedDto | null) => {
  const [likeTimeout, setLikeTimeout] = useState<NodeJS.Timeout>();

  // Initialize event bus for like status changes
  const { emit } = useEventBus<FeedLikeEvent>(FEED_LIKE_EVENT);

  const handleLike = useCallback((isLiked: boolean) => {
  if(!feed) return;
    if(!feed.sid) return;

    if(likeTimeout) {
      clearTimeout(likeTimeout);
    }

    setLikeTimeout(setTimeout(async () => {
      try {
        if(!feed) return;
        if(!feed.sid) return;
        if (isLiked) {
          await api.feedLike.like(feed.sid); // Note: API naming is counterintuitive
        } else {
          await api.feedLike.unlike(feed.sid); // Note: API naming is counterintuitive
        }

        // Emit event to notify other components about the like status change
        emit({
          feedId: feed.sid,
          isLiked: isLiked,
          likeCount: isLiked ? (feed.likeCount || 0) + 1 : Math.max(0, (feed.likeCount || 0) - 1)
        });
      } catch (error) {
        console.error('Error toggling like:', error);
      }
      setLikeTimeout(undefined);
    }, 300));
  }, [feed?.sid, feed?.likeCount, likeTimeout, emit]);

  return {
    handleLike,
  };
};
